import { Product, ProductListConfig } from "../types/types";
import { layoutMap as cardLayouts } from "../product-card-layouts/layoutMap";
import { raise } from "../utils/raise";
import { VariantProvider } from "@~/contexts/VariantContext/VariantContext";

export type Props = {
  config: ProductListConfig;
  product: Product;
  index: number;
};

export function ProductCard({ product, config, index }: Props) {
  const { name: cardLayoutName, props: cardLayoutProps } =
    config["product-card-layout"];
  const CardLayout =
    cardLayouts[cardLayoutName] ||
    raise(`Couldn't find product-card layout "${cardLayoutName}"`);

  return (
    <VariantProvider product={product}>
      <CardLayout
        config={config}
        product={product}
        configProps={cardLayoutProps}
        index={index}
      />
    </VariantProvider>
  );
}
